export default "__VITE_ASSET__CGSDRUG0__"